import cn from 'clsx'
import Clickable from 'components/Common/Clickable'
import Image from 'components/Common/Image'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import SolidBellRingIcon from 'LuxKit/Icons/solid/SolidBellRingIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Sheet from 'components/utils/Sheet'
import { usePlaceById } from 'hooks/usePlace'
import { getDestinationImage } from 'lib/search/searchUtils'
import { rem } from 'polished'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { UserPreferenceDestination } from '../types'

const Item = styled(Clickable)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

const ImageSheet = styled(Sheet)`
  position: relative; /* for the floating checkbox */
  aspect-ratio: 3/2;
`

const FloatingCheckbox = styled(CheckboxButton)`
  position: absolute;
  top: ${rem(8)};
  right: ${rem(8)};
  opacity: 0;
  transition: opacity 0.2s;

  &.visible {
    opacity: 1;
  }
`

interface Props {
  item: UserPreferenceDestination
  isSelected: boolean
  onSelect: (item: UserPreferenceDestination) => void
  showLabel: boolean
}

function TravelPreferencesDestinationOptionItem({
  item,
  isSelected,
  onSelect,
  showLabel,
}: Props) {
  const place = usePlaceById(item.placeId, !!item.name)
  const image = item.imageId || getDestinationImage(item.placeId)
  const imageAlt = item.name || place?.name
  const handleClick = useCallback(() => {
    onSelect(item)
  }, [item, onSelect])

  return <Item onClick={handleClick}>
    <ImageSheet border={isSelected ? 'primary' : 'transparent'} borderWidth={2} background="neutral-seven">
      {!!image && <Image
        id={image}
        alt={imageAlt}
        fit="center"
        aspectRatio="3:2"
        width="192"
        dpr={2}
      />}
      <FloatingCheckbox size="large" checked className={cn({ visible: isSelected })} />
    </ImageSheet>
    {showLabel && <BodyTextBlock
      endIcon={item.isAlertSelected && <SolidBellRingIcon />}
      variant="medium"
      weight="bold"
      colour="neutral-two"
    >
      {item.name || place?.name}
    </BodyTextBlock>}
  </Item>
}

export default TravelPreferencesDestinationOptionItem
